/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-07-30 11:46.
 */
const BaseCategoryPage = require( 'base/category-page' );
const BaseInfo = require( 'purchasing-federation/member-info/common/base-info' );
const MemberShip = require( 'purchasing-federation/member-info/common/member-ship' );
const ModifyPassword = require( 'purchasing-federation/member-info/common/modify-password' );
const MemberAtlas = require( 'purchasing-federation/member-info/common/member-atlas' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

class PurchaseMemberInfo extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .tab-item': 'changeTab',
        'click .commit-password': 'commitPasswodr',
        'click .del-atlas': 'delAtlas',
        'click .set-as-cover': 'setAsCover',
        'click .payment': 'payment',
        'click .edit-payment': 'editPayment',
        'click .view-payment': 'viewPayment',
        'change .file': 'fileChange',
        'change .upload-controller': 'uploadController',
        'click .delete-img': 'deleteImg',
        'click .submit-payment': 'submitPayment',
        'click .modify-password .close': 'closeModal'
      }
    } );
  }

  async init() {
    const data = initMenu( 'MemberInfo', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    const activeTab = this.$el.find( '.tab-item.active' );
    const { value } = activeTab.data();
    super.init();
    await this[ value ]();
  }

  // 切换tab
  changeTab( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    const { value } = $el.data();
    if ($el.hasClass( 'active' )) {
      return false;
    }
    this.$el.find( '.info-wrap' ).html( '' );
    $el.addClass( 'active' ).siblings().removeClass( 'active' );
    /**
     * 初始化Tab
     * value              tab类型
     * ├─ baseinfo        基本信息
     * ├─ membership      会费信息
     * ├─ modifypassword  修改密码
     * └─ memberatlas     会员图册
     *
     */
    this[ value ]();
  }

  // 勿删，该方法会在父类中调用
  search() {
  }

  // 初始化基本信息
  async baseinfo() {
    BaseInfo.init.apply( this );
  }

  // 初始化会费信息
  async membership() {
    MemberShip.init.apply( this );
  }

  // 初始化修改密码
  modifypassword() {
    ModifyPassword.init.apply( this );
  }

  // 初始化会员图册
  async memberatlas() {
    MemberAtlas.init.apply( this );
  }

  // 删除汇款凭证
  deleteImg( e ) {
    MemberShip.deleteImg.apply( this, [ e ] );
  }

  // 缴费
  payment( e ) {
    MemberShip.payment.apply( this, [ e ] );
  }

  // 编辑缴费信息
  editPayment( e ) {
    MemberShip.editPayment.apply( this, [ e ] );
  }

  // 查看缴费信息
  viewPayment( e ) {
    MemberShip.viewPayment.apply( this, [ e ] );
  };

  uploadController( e ) {
    MemberShip.uploadController.apply( this, [ e ] );
  }

  // 提交会费信息
  async submitPayment( e ) {
    MemberShip.submitPayment.apply( this, [ e ] );
  }

  // 提交密码修改
  async commitPasswodr() {
    ModifyPassword.commitPasswodr.apply( this );
  }

  closeModal() {
    ModifyPassword.closeModal.apply( this );
  }

  // 上传图片。获取oss地址
  fileChange( e ) {
    MemberAtlas.fileChange.apply( this, [ e ] );
  }

  // 设置为封面
  setAsCover( e ) {
    MemberAtlas.setAsCover.apply( this, [ e ] );

  }

  // 删除会员图册
  delAtlas( e ) {
    MemberAtlas.delAtlas.apply( this, [ e ] );
  }
}

module.exports = PurchaseMemberInfo;
